import setHeaderOffset from '../../../../../../../Project/MainSite/code/Scripts/mainsiteUtils.js';

/*jshint esversion: 6 */
$(document).ready(function () {
    $(".alert-msg-close").click(function () {
        var alertSection = ($(this).closest(".alert-row"));
        var alertId = alertSection[0].dataset.alertId;
        var expireDate = alertSection[0].dataset.alertExpDate;
        SetAlertCookie(alertId, expireDate, alertSection);
        alertSection.remove();
        EvalAlertHeight();
        setHeaderOffset();
        EvalMegaMenuMobilePosition();
        EvalCollasiblePanelPosition();
    });

    $(".reminder-msg-close").click(function () {
        var reminderSection = ($(this).closest(".reminder-row"));
        var reminderId = reminderSection[0].dataset.reminderId;
        SetReminderSessionEntry(reminderId);
        reminderSection.remove();
        EvalReminderHeight();
        setHeaderOffset();
        EvalCollasiblePanelPosition();
    });

    $("#btnPromoClose").click(function (e) {
        e.preventDefault();

        $.ajax({
            url: $(this).attr("href"),
            success: function (data) {
                console.log("success");
                RemovePromo();
                setHeaderOffset();
                EvalCollasiblePanelPosition();
                EvalMegaMenuMobilePosition();
            },
            error: function (fail) {
                console.log("error");
                RemovePromo();
                setHeaderOffset();
                EvalCollasiblePanelPosition();
                EvalMegaMenuMobilePosition();
            }
        });
    });

    $("#btnCloseCouponBanner").click(function () {
        SetCouponBanner();
        setHeaderOffset();
        EvalCollasiblePanelPosition();
        EvalMegaMenuMobilePosition();
    });

    //var divpromoplcholder = $(".promo-placeholder");
    //if (divpromoplcholder != undefined) {
    //    //divpromoplcholder.hide();
    //    //var divcoupondis = $("#div-promo-display, .promo-placeholder");

    //    if (divcouponbannerdisplay.length) {
    //        divpromoplcholder.hide();
    //    }
    //}   

    var myAlerts = $(".alert-row");
    for (let i = 0; i < myAlerts.length; i++) {
        var alertId = myAlerts[i].dataset.alertId;
        CheckCookie(alertId, myAlerts[i]);
    }

    var myReminders = $(".reminder-row");
    for (let i = 0; i < myReminders.length; i++) {
        var reminderId = myReminders[i].dataset.reminderId;
        CheckSession(reminderId, myReminders[i]);
    }

    GetCouponBanner();
    EvalCouponBannerHeight();
    EvalAlertHeight();
    EvalReminderHeight();
    setHeaderOffset();
    EvalCollasiblePanelPosition();
    EvalMegaMenuMobilePosition();
});

$(window).on('resize', function () {
    setTimeout(function () {
        setHeaderOffset();
        EvalCollasiblePanelPosition();
        EvalMegaMenuMobilePosition();
    }, 200 );
});

var headerWrapper = $('.header-wrapper');
var alertWrapper = $("#div-alert-display");
var reminderWrapper = $("#div-reminder-display");
var divcouponbannerdisplay = $("#div-couponbanner-display, .couponbanner-placeholder");
var couponbannerWrapper = $("#div-couponbanner-display");
var couponbannerPlaceholder = $(".couponbanner-placeholder");
var cookiedValueCouponBanner = divcouponbannerdisplay.attr("data-couponbanner-id");

function SetAlertCookie(alertId, expireDate) {
    document.cookie = "alert_" + alertId + "=" + alertId + ";expires=" + expireDate + "domain=;path=/";
}

function SetReminderSessionEntry(reminderId) {
    sessionStorage.setItem("reminder_" + reminderId, reminderId)
}

function CheckCookie(alertId, myAlert) {
    if (document.cookie.indexOf("alert_" + alertId) !== -1) {
        myAlert.remove();
    }
}

function CheckSession(reminderId, myReminder) {
    var sessionCheck = sessionStorage.getItem("reminder_" + reminderId)
    if (sessionCheck !== null) {
        myReminder.remove();
    }
}


function EvalAlertHeight() {
    var alertRows = alertWrapper.find(".alert-row");
    if (alertRows.length === 0) {
        alertWrapper.remove();
    }
}

function EvalReminderHeight() {
    var reminderRows = reminderWrapper.find(".reminder-row");
    if (reminderRows.length === 0) {
        reminderWrapper.remove();
    }
}

function EvalCollasiblePanelPosition() {
    var headerWrapperHeight = headerWrapper.is(':visible') ? headerWrapper.outerHeight() : 0;
    var collapsiblePanel = $(".mega-menu .collapsible-panel");
    var collapsibleMoreSection = $(".mega-menu .more-items-wrapper");
    collapsiblePanel.css("top", headerWrapperHeight);
    collapsibleMoreSection.css("top", headerWrapperHeight);
}

function EvalMegaMenuMobilePosition() {
    var headerWrapperHeight = headerWrapper.is(':visible') ? headerWrapper.outerHeight() : 0;
    var headerHeightMobile = $('header.mobile').outerHeight();
    var windowHeight = $(window).height();

    if ($(window).width() < 768) {
        var megaMenuMobile = $(".mega-menu");
        megaMenuMobile.css('max-height', windowHeight - headerWrapperHeight);
        //console.log("4 - max height", windowHeight - headerHeightMobile - headerWrapperPlaceholderHeight);
    }
}

function RemovePromo() {
    var divpromo = $("#div-promo-display, .promo-placeholder");

    if (divpromo.length) {
        divpromo.remove();
    }
}

if (divcouponbannerdisplay.attr("data-couponbanner-exp-date")) {
    var cookieExpireDate = new Date(divcouponbannerdisplay.attr("data-couponbanner-exp-date").toString());
}

function SetCouponBanner() {
    document.cookie = "couponbanner_" + cookiedValueCouponBanner + "=" + cookiedValueCouponBanner + ";expires=" + cookieExpireDate;
    HideCouponBanner();
}

function GetCouponBanner() {
    if (document.cookie.indexOf(cookiedValueCouponBanner) !== -1) {
        HideCouponBanner();
    }
}

function HideCouponBanner() {
    if (divcouponbannerdisplay != undefined) {
        divcouponbannerdisplay.remove();
    }
}

function EvalCouponBannerHeight() {
    var couponbannerWrapperHeight = couponbannerWrapper.outerHeight();
    couponbannerPlaceholder.height(couponbannerWrapperHeight);
}